import { formatSecondsToHours, secondsToTime } from "@src/utils/time";
import type { Time } from "@src/utils/types";
import { FieldState } from "formstate";

export class TimeFieldState extends FieldState<number> {
  /** Get the value in hours (computed only when called, not reactive) */
  getHours(): number {
    return this.value / 3600;
  }

  /**
   * Format the seconds to hours with the given decimals and add the "h" suffix.
   */
  formatToDecimals(decimals = 0): string {
    return formatSecondsToHours(this.value, decimals);
  }

  format(): Time | undefined {
    return secondsToTime(this.value);
  }
}
